import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import UserAccessFields from './UserAccessFields';

const UserEditorDialog = ({
    tab,
    wasteReceivers,
    companyOptionIds,
    getWasteReceiverDisplayLabel,
    getCompanyDisplayLabel,
    loadingReceivers,
    loadingCompanies,
    saving,
}) => {
    const {
        closeUserEditor,
        editingUser,
        getUserDraftMembershipPermission,
        saveUserDraft,
        updateUserDraftCompanies,
        updateUserDraftMembershipPermission,
        updateUserDraftWasteReceivers,
        userDraft,
    } = tab;

    return (
            <Dialog
                open={Boolean(editingUser)}
                onClose={closeUserEditor}
                className="setup-dialog"
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle>{editingUser?.label || 'Rediger bruger'}</DialogTitle>
                <DialogContent className="setup-user-dialog-content">
                    <div className="setup-field-grid">
                        <div className="setup-field-label">Bruger-id</div>
                        <div>{editingUser?.id}</div>

                        <div className="setup-field-label">Admin</div>
                        {/* isAdmin is not writable by any client (see firestore.rules), so it is
                            shown for context and filtered on, but never edited here. */}
                        <div>{editingUser?.isAdmin ? 'Ja' : 'Nej'}</div>
                    </div>

                    <UserAccessFields
                        wasteReceiverIds={userDraft.wasteReceivers}
                        companyIds={userDraft.companies}
                        wasteReceiverOptions={wasteReceivers.map((receiver) => receiver.id)}
                        companyOptionIds={companyOptionIds}
                        getPermission={getUserDraftMembershipPermission}
                        onWasteReceiversChange={updateUserDraftWasteReceivers}
                        onCompaniesChange={updateUserDraftCompanies}
                        onPermissionChange={updateUserDraftMembershipPermission}
                        getWasteReceiverDisplayLabel={getWasteReceiverDisplayLabel}
                        getCompanyDisplayLabel={getCompanyDisplayLabel}
                        loadingReceivers={loadingReceivers}
                        loadingCompanies={loadingCompanies}
                        disabled={saving}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeUserEditor} disabled={saving}>
                        Annuller
                    </Button>
                    <Button
                        variant="contained"
                        startIcon={<SaveIcon />}
                        onClick={saveUserDraft}
                        disabled={saving}
                    >
                        Gem
                    </Button>
                </DialogActions>
            </Dialog>
    );
};

export default UserEditorDialog;
